/**
 * Système de cache simple pour les produits
 * Permet d'éviter les requêtes répétées à Supabase
 */

const CACHE_KEY = 'rdp_products_cache_v5'; // v5: force reload
const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes

/**
 * Récupère les produits depuis le cache
 * @returns {Object|null} - Produits en cache ou null si expiré/vide
 */
export function getProductsFromCache() {
  try {
    const cached = localStorage.getItem(CACHE_KEY);
    if (!cached) return null;

    const { data, timestamp } = JSON.parse(cached);
    const now = Date.now();

    // Vérifier si le cache est toujours valide
    if (now - timestamp < CACHE_DURATION) {
      console.log('✅ Produits chargés depuis le cache');
      return data;
    }

    // Cache expiré
    console.log('⏰ Cache expiré, rechargement nécessaire');
    return null;
  } catch (error) {
    console.error('Erreur lecture cache:', error);
    return null;
  }
}

/**
 * Sauvegarde les produits dans le cache
 * @param {Array} products - Liste des produits à mettre en cache
 */
export function setProductsCache(products) {
  try {
    const cacheData = {
      data: products,
      timestamp: Date.now()
    };
    localStorage.setItem(CACHE_KEY, JSON.stringify(cacheData));
    console.log('💾 Produits mis en cache');
  } catch (error) {
    console.error('Erreur sauvegarde cache:', error);
  }
}

/**
 * Invalide le cache (à appeler lors d'ajout/modification de produits)
 */
export function clearProductsCache() {
  try {
    localStorage.removeItem(CACHE_KEY);
    console.log('🗑️ Cache produits invalidé');
  } catch (error) {
    console.error('Erreur suppression cache:', error);
  }
}

/**
 * Force le rechargement des produits en invalidant le cache
 */
export function forceRefreshProducts() {
  clearProductsCache();
  window.location.reload();
}
